import { get } from 'lodash';
import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { periodTypeLabel } from '@utils/utils';

export default [
  {
    label: 'Od',
    field: 'from',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Do',
    field: 'to',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Typ',
    field: 'type',
    type: ColumnType.JSX,
    jsx: ({ row }) => periodTypeLabel(get(row, 'type')),
    width: 200
  }
];



// WEBPACK FOOTER //
// ./src/modules/hr-templates/periods/_periodsColumns.tsx